import dashboard from './dashboard';
import userManagement from './userManagement';
import { NavItemType } from 'types';
import settings from './settings';
import promoCodesManagemant from './promoCode';
import payout from './payout';

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, userManagement, promoCodesManagemant, payout, settings]
};

export default menuItems;
